export default "__VITE_ASSET__BxbjstWM__"